import { debounce } from "lodash"
import axiosInstance from "@/utils/axiosConfig"

export default (debounceTime) => ({
	data: () => ({
		errors: {
			email: "",
			nickname: ""
		},
		values: {
			email: "",
			nickname: ""
		}
	}),
	methods: {
		debouncedUniquenessValidation: debounce(function(
			field,
			value,
			expr = "uniqueness"
		) {
			this.validateUniqueness(field, value, expr)
		},
		debounceTime),

		async validateUniqueness(field, value, expr) {
			if (this.values[field] !== value) {
				const { removeError, setError } = this
				if (value) {
					console.log("executed")

					const {
						data: { success, msg }
					} = await axiosInstance.get(
						`/auth/register/check-uniqueness?field=${field}&value=${value}`
					)
					let condition
					if (expr === "uniqueness") {
						condition = success
					} else {
						condition = !success
					}

					if (!condition) {
						setError(field, msg)
					} else {
						removeError(field)
					}
				} else {
					removeError(field)
				}
			}
			this.values[field] = value
		},
		setError(field, message) {
			this.errors[field] = message
			console.log(this.errors)
		},
		removeError(field) {
			this.errors[field] = ""
		}
	}
})
